/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var _get = require('lodash.get');
var Backbone = require('backbone');
var NProgress = require('nprogress');

var GetNotification = require('common/services/GetNotification');
var GetLicenseIdentifiers = require('../../../license-dashboard/services/GetLicenseIdentifiers');
var GetEntityExternalUserAccessLevelByEntity = require('../../../entity-dashboard/services/GetEntityExternalUserAccessLevelByEntity');

var VerifyContactsRequestTaskView = require('./VerifyContactsRequestTaskView');

module.exports = {
  event: 'build:nd:entity-verify-contacts-request-notification',

  channel: 'task',

  builder: function(task) {
    var defer = $.Deferred();

    var notificationId = _get(task, 'taskData.CM.notificationId');
    var entityId = _get(task, 'taskData.ND.entityId');
    var licenseId = _get(task, 'taskData.ND.licenseId');

    $.when(
      GetNotification(notificationId),
      GetLicenseIdentifiers(licenseId),
      GetEntityExternalUserAccessLevelByEntity(entityId)
    )
      .done(function(notification, licenseIdentifiers, externalUser) {
        NProgress.set(0.85);

        defer.resolve(
          new VerifyContactsRequestTaskView({
            model: new Backbone.Model({
              task: task,
              taskId: task.taskId,
              entityId: entityId,
              licenseId: licenseId,
              notification: notification,
              licenseIdentifiers: licenseIdentifiers,
              notificationId: notificationId,
              accessLevelId: externalUser.accessLevelId
            })
          })
        );
      })
      .fail(function(err) {
        defer.reject(err);
      });

    return defer.promise();
  }
};
